// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5405":"4adf790f7857d5eb","8762":"4adf790f7857d5eb"}[chunkId] + ".css";
};